// extracted by mini-css-extract-plugin
module.exports = {"installation-tips":"PostcodeQueryPopUp_installation-tips__vKU3x"};